import React from 'react';
import BookstoreLayout from '../bookstore-layout';
import Layout from '../../layout';

const ServicePartsLiteratureLayout: React.FC = ({ children }) => (
  <Layout title="Service Parts Literature">
    <BookstoreLayout
      title="Service Parts Literature"
      subtitle='Welcome to the Service/Parts Literature page of this website. The materials available for purchase in this section are either printed documents or individual PDF files available for download. Choose your model from the dropdown below, then you can refine your search by Model Year, Category of Manual and/or Manual Type. In the Subscription area of this site, you can order a subscription to all of the bulletins in the database of a certain type (service bulletins, MSDS and TJs). You can also order a PDF version of specific wiring diagrams in the "Subscriptions" area. Beginning in model year 1999, most service manuals moved from paper format to a fully electronic environment called VIDA. Click here to find out more about VIDA.'
      breadcrumb={{ url: '/parts', text: 'Back' }}
      hero=""
    >
      {children}
    </BookstoreLayout>
  </Layout>
);

export default ServicePartsLiteratureLayout;
